// GENERATED BY ./src/scripts/generateComponents.ts
// DO NOT EDIT IT MANUALLY

import React from "react";

import { iconStatausdm } from "../../../icons/full/build/icon-statausdm.icon";
import { IconComponentBaseProps } from "../../../utils";
import { Image } from "../../Base/Image";

const StatausdmIcon = (props: IconComponentBaseProps) => {
  return <Image svgCode={iconStatausdm.data} {...props} />;
};

if (process.env.NODE_ENV !== 'production') {
  StatausdmIcon.displayName = 'StatausdmIcon';
}

export default StatausdmIcon;